import {StackScreenProps} from '@react-navigation/stack';
import {Box, Button} from 'native-base';
import React, {useEffect, useRef, useState} from 'react';
import {ScrollView, TextInput} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {t} from 'react-native-tailwindcss';
import {AmountInput} from '../../components/AmountInput';
import {KeyboardAvoidingView} from '../../components/KeyboardAvoidingView';
import {PropertyList} from '../../components/PropertyList';
import {formatPhone} from '../../lib/formatters';
import i18n from '../../lib/i18n';
import {Nav, NavParams} from '../navigation';
import {config} from '../../stage.config';

const MAX_AMOUNT = config.production ? 1000 : 100000;

export const CreatePaymentAmountScreen: React.FC<
  StackScreenProps<NavParams, Nav.CreatePaymentAmountScreen>
> = ({navigation, route}) => {
  const {phoneNumber} = route.params;
  const [amount, setAmount] = useState(0);
  const inputRef = useRef<TextInput>(null);

  useEffect(() => {
    return navigation.addListener('transitionEnd', (nativeEvent) => {
      if (!nativeEvent.data.closing) {
        inputRef.current?.focus();
      }
    });
  }, [navigation]);

  const handleSubmit = () => {
    if (amount === 0) return;
    return navigation.navigate(Nav.CreatePaymentMessageScreen, {amount, phoneNumber});
  };

  const isTooLarge = amount > MAX_AMOUNT;
  const isInvalid = isTooLarge || amount <= 0;

  return (
    <SafeAreaView style={[t.flex1, t.bgWhite]} edges={['bottom']}>
      <KeyboardAvoidingView offset={125}>
        <PropertyList
          properties={[
            {
              label: i18n.t('toPhoneNumber'),
              value: formatPhone(phoneNumber)
            }
          ]}
        />
        <ScrollView
          contentContainerStyle={[t.flex1, t.flex, t.flexCol, t.justifyCenter]}
          keyboardShouldPersistTaps="handled">
          <AmountInput
            ref={inputRef}
            onAmountChange={setAmount}
            amount={amount}
            onSubmit={handleSubmit}
            maxAmount={MAX_AMOUNT}
            returnKeyType="next"
            getMaxAmountErrorMessage={(maxAmountString: string) =>
              i18n.t('maxAmountError', {
                amount: maxAmountString
              })
            }
          />
        </ScrollView>
        <Box style={[t.p4]}>
          <Button isDisabled={isInvalid} onPress={handleSubmit}>
            {i18n.t('continue')}
          </Button>
        </Box>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};
